import { ParticleBehaviourTagType } from 'app/enum/Particles';
import { ParticleBehaviour } from '../ParticleBehaviour';

export class ParticleTexture extends ParticleBehaviour {
	//Set default tag type for behaviour:
	protected _tags: Array<ParticleBehaviourTagType> = [ParticleBehaviourTagType.TEXTURE];

	//Public
	//-------------------------------------------------------------------------------------
	public set(texture: PIXI.Texture) {
		this._particleProps.sprite.texture = texture;
	}
}
